'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginScreen = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _auth = require('redux/modules/auth');

var _containers = require('containers');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginScreen = exports.LoginScreen = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(LoginScreen, _Component);

  function LoginScreen() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LoginScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginScreen.__proto__ || (0, _getPrototypeOf2.default)(LoginScreen)).call.apply(_ref, [this].concat(args))), _this), _this._submit = function (credentials) {
      if (_this.props.doLogin) {
        _this.props.doLogin((0, _stringify2.default)(credentials));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LoginScreen, [{
    key: 'render',
    value: function render() {
      var styles = require('./LoginScreen.scss');
      var logo = require('../App/travelport-redefining-logo.png');

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_containers.LoadingOverlay, null),
        _react2.default.createElement(_components.EnterpriseHeader, {
          className: styles.header,
          logo: logo,
          homeUrl: _config2.default.app.homeUrl
        }),
        _react2.default.createElement(
          'div',
          { className: 'inner-scroll-layout' },
          _react2.default.createElement(
            'div',
            { className: 'inner-scroll-wrapper' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('inner-scroll-scrollable', styles.wrapper) },
              _react2.default.createElement(_components.Login, { onSubmit: this._submit })
            )
          )
        ),
        _react2.default.createElement(_components.EnterpriseFooter, { className: styles.footer })
      );
    }
  }]);
  return LoginScreen;
}(_react.Component), _class.propTypes = {
  doLogin: _react.PropTypes.func
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: state.isAuthenticated
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { doLogin: _auth.doLogin.base })(LoginScreen);


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginScreen/LoginScreen.jsx
// module id = 1634
// module chunks = 0